import { Destination, FormField } from "@prequel/react";
import { CopyToClipboard } from "@prequel/shared-components";

import { WrapperProps } from "..";
import SSHPublicKey from "./SSHPublicKey";

import { MagicLink } from "@/types";
import { Source } from "@/types/sources";
import { SourceFormField } from "@/types/sources/form";

const ConstWrapper = <F extends FormField | SourceFormField, C extends Destination | Source | MagicLink>({
  field,
  connection,
  setConnectionField,
  isEditing,
}: WrapperProps<F, C>) => {
  if (!field.const) {
    return <></>;
  }

  if (field.name.includes("public_key")) {
    return (
      <SSHPublicKey
        field={field}
        connection={connection}
        setConnectionField={setConnectionField}
        isEditing={isEditing}
      />
    );
  }

  return (
    <>
      <label className="block text-sm font-medium text-gray-700">{field.label}</label>
      {typeof field.const === "object" ? (
        <div
          className="
            mt-1 inline-flex w-full resize-y overflow-auto rounded-md border border-gray-300 bg-gray-50 py-2 pr-1 pl-3
            font-mono text-sm text-gray-500 shadow-sm
          "
        >
          <div className="mr-3 h-14 w-full whitespace-pre-wrap">{JSON.stringify(field.const, null, 2)}</div>
          <CopyToClipboard textToCopy={JSON.stringify(field.const, null, 2)} className="sticky top-0 self-start" />
        </div>
      ) : (
        <div
          className="
            mt-1 inline-flex w-full rounded-md border border-gray-300 bg-gray-50 py-2 pr-1 pl-3 font-mono text-sm
            text-gray-500 shadow-sm
          "
        >
          <div className="mr-3 w-full truncate">{field.const}</div>
          <CopyToClipboard textToCopy={field.const} />
        </div>
      )}
      {field.description && (
        <p className="mt-2 text-xs whitespace-pre-line text-gray-400" id="description">
          {field.description}
        </p>
      )}
    </>
  );
};

export default ConstWrapper;
